export const spacing = {
    xs: '0.125rem',
    sm: '0.25rem',
    md: '0.5rem',
    lg: '0.75rem',
    xl: '1rem',
    '2xl': '1.5rem',
    '3xl': '2rem',
    '4xl': '2.5rem',
    '5xl': '3rem',
    '6xl': '3.5rem',
    '7xl': '4rem',
    '8xl': '6rem',
    '9xl': '10rem',
};
